import { createTheme } from '@mui/material/styles';

// Light theme — neutral surfaces with #7c3aed as the brand color.
// Status accents (success / warning / error) stay distinct from the brand
// so chips like "running" stay amber, not purple.
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#7C3AED',
      dark: '#6D28D9',
      light: '#A78BFA',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#0B0B0F',
      dark: '#000000',
      light: '#3F3F46',
      contrastText: '#FFFFFF',
    },
    success: {
      main: '#10B981',
      dark: '#059669',
      light: '#34D399',
    },
    warning: {
      main: '#F59E0B',
      dark: '#B45309',
      light: '#FBBF24',
    },
    error: {
      main: '#EF4444',
      dark: '#B91C1C',
      light: '#F87171',
    },
    info: {
      main: '#0EA5E9',
      dark: '#0369A1',
      light: '#38BDF8',
    },
    background: {
      default: '#FAFAFA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#000000',
      secondary: '#6B6B6B',
      disabled: '#A1A1A1',
    },
    divider: 'rgba(0, 0, 0, 0.08)',
    action: {
      hover: 'rgba(124, 58, 237, 0.06)',
      selected: 'rgba(124, 58, 237, 0.10)',
      focus: 'rgba(124, 58, 237, 0.16)',
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, "Segoe UI", "Roboto", sans-serif',
    h1: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 700, letterSpacing: '-0.025em' },
    h2: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 700, letterSpacing: '-0.022em' },
    h3: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 600, letterSpacing: '-0.018em' },
    h4: { fontFamily: '"Inter Tight", "Inter", sans-serif', fontWeight: 600, letterSpacing: '-0.015em' },
    h5: { fontWeight: 600, letterSpacing: '-0.01em' },
    h6: { fontWeight: 600, letterSpacing: '-0.01em' },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          textRendering: 'optimizeLegibility',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
          borderRadius: 10,
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          border: '1px solid rgba(0, 0, 0, 0.08)',
          boxShadow: '0 1px 2px rgba(0, 0, 0, 0.03)',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: { backgroundImage: 'none' },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          backgroundColor: 'rgba(255, 255, 255, 0.85)',
          color: '#0B0B0F',
          backdropFilter: 'blur(20px)',
          borderBottom: '1px solid #E6E7EB',
          boxShadow: 'none',
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: { borderColor: '#E6E7EB' },
      },
    },
  },
});

export default theme;
